import React from 'react'
import { ConfigProvider } from 'antd'
import { IntlProvider } from 'react-intl'
import { connect } from 'react-redux'
import english from 'locales/en-US'
import englishHelp from 'locales/help/en-US'
import german from 'locales/de-DE'
import germanHelp from 'locales/help/de-DE'

export const locales = {
  'en-US': { ...english, help: englishHelp },
  'de-DE': { ...german, help: germanHelp },
}

@connect(({ settings }) => ({ settings }))
class Localization extends React.Component {
  render() {
    const {
      children,
      settings: { locale },
    } = this.props
    const currentLocale = locales[locale]
    const messages = { ...currentLocale.messages, ...currentLocale.help }
    return (
      <ConfigProvider locale={currentLocale.antdData}>
        <IntlProvider locale={currentLocale.locale} messages={messages}>
          {children}
        </IntlProvider>
      </ConfigProvider>
    )
  }
}

export default Localization
